import React, { FC, useCallback, useContext, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { AppStateContext, useRefresh, useRest } from '../../../../../components/Context'
import { data } from './BalanceTableLists'
import { icons } from '../../../../../constants/icons'
import { GreenButton } from '../../../../../components/Dashboard/Buttons/GreenButton'
import { TableSimple } from '../../../../../components/Dashboard/TableSimple'
import { MemoFundAccountPopup } from '../../TreasuryManagment/TreasurySections/FundAccountPopup'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    minHeight: 40,
    maxHeight: 40,
    paddingBottom: theme.spacing(2),
  },
  sectionWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
    padding: theme.spacing(4, 4, 2, 4),
    background: 'rgb(49,52,58)',
  },
  section: {
    maxWidth: 300,
  },
  button: {
    justifyContent: 'center',
    // paddingTop: theme.spacing(2),
  },
}))
interface BalanceSectionProps {
  title: string
}

export const Balance: FC<BalanceSectionProps> = ({ title }) => {
  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })
  const classes = useStyles()
  const { rxiosAuth } = useRest()
  const { getIsRefresh } = useContext(AppStateContext)
  const { saveIsRefresh } = useRefresh()
  const [isOpenModal, setOpenModal] = useState<boolean>(false)
  const [refresh, setRefresh] = useState<boolean | undefined>()
  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [values, setValues] = useState<any>({})

  useEffect(() => setRefresh(getIsRefresh()), [setRefresh, getIsRefresh])

  const openModal = useCallback(() => {
    setOpenModal((prevState) => !prevState)
  }, [setOpenModal])

  const closeModal = useCallback(() => {
    setOpenModal(false)
  }, [setOpenModal])

  const loadData = useCallback(async () => {
    let cleanupFunction = false
    setLoading(true)
    rxiosAuth.get(data.request).subscribe(
      // eslint-disable-next-line
      (next: any) => {
        setValues(next)
        if (!cleanupFunction) setLoading(false)
      },
      (error) => {
        toast.error(error)
        setLoading(false)
      },
      () => {
        setLoading(false)
        setTimeout(() => {
          saveIsRefresh(false)
        }, 2000)
      },
    )
    cleanupFunction = true
    // eslint-disable-next-line
  }, [rxiosAuth])

  useEffect(() => {
    ;(async () => {
      await loadData()
    })()
    // eslint-disable-next-line
  }, [refresh])

  useEffect(() => {
    if (refresh) {
      ;(async () => {
        await loadData()
      })()
    }
    // eslint-disable-next-line
  }, [refresh])

  return (
    <>
      <Grid item xs={12} className={classes.formWrap}>
        <FormProvider {...formMethods}>
          <Grid item xs={12} className={classes.container}>
            <Typography variant={'h6'}>{title}</Typography>
          </Grid>

          <Grid item xs={12} className={classes.sectionWrap}>
            <Grid item className={classes.section}>
              <TableSimple columns={data.columns} data={values} loading={loading} />
            </Grid>

            <GreenButton text={'Add Balance'} prefix={icons.ADD} width={136} onClick={openModal} />
          </Grid>
        </FormProvider>
      </Grid>

      <MemoFundAccountPopup isOpen={isOpenModal} modalClose={closeModal} />
    </>
  )
}
